import { Controller } from 'stimulus';
import Swiper, { Navigation, Pagination } from 'swiper';

class ImageSlider extends Controller {
  connect() {
    Swiper.use([Navigation, Pagination]);

    const dynamicWidth = this.data.get('dynamic') === '1';

    this.swiper = new Swiper(this.element, {
      slidesPerView: dynamicWidth ? 'auto' : 1,
      freeMode: dynamicWidth,
      spaceBetween: 20,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom(swiper, current, total) {
          const count = `${current}/${total}`;

          const barWidth = 100 / total;
          const barLeftOffset = barWidth * (current - 1);

          return `
              <div class="slider__pagination-bar">
                  <span style="left: ${barLeftOffset}%; width: ${barWidth}%"></span>
              </div>
              <span class="slider__pagination-count">${count}</span>
          `;
        },
      },
      breakpoints: {
        992: {
          spaceBetween: 40,
        },
      },
    });
  }
}

export default ImageSlider;
